import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login_layout" }
const _hoisted_3 = { class: "login_layout_inner" }
const _hoisted_4 = { class: "inner" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { style: {"position":"relative","top":"5px","left":"5px"} }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "layout_content" }
const _hoisted_9 = { class: "main_inner" }
const _hoisted_10 = { class: "input-item" }
const _hoisted_11 = { class: "input-item" }
const _hoisted_12 = { class: "input-item" }
const _hoisted_13 = {
  class: "custom_theme_container",
  style: {"margin-top":"15px"}
}
const _hoisted_14 = { class: "custom_theme_input_group" }
const _hoisted_15 = {
  for: "remember",
  style: {"padding-top":"2px","color":"rgb(60, 60, 60)","cursor":"pointer"}
}
const _hoisted_16 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { style: {"flex":"1","line-height":"40px"} }
const _hoisted_19 = { style: {"flex":"1","line-height":"40px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, {
    fullscreen: "",
    "scroll-y": "false",
    style: {"background-color":"white","overflow":"auto"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("header", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("img", {
                        src: "/assets/logo_white.png",
                        width: "125"
                      }, null, -1)),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('Security Center')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("main", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createElementVNode("form", {
                        class: "login-form",
                        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.t('username')), 1),
                          _createVNode(_component_b_form_input, {
                            modelValue: _ctx.username,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                            name: "username",
                            placeholder: _ctx.t('username')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.t('password')), 1),
                          _createVNode(_component_b_form_input, {
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                            type: "password",
                            name: "password",
                            placeholder: _ctx.t('password')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.t('language')), 1),
                          _createVNode(_component_b_form_select, {
                            modelValue: _ctx.language,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.language) = $event)),
                            options: _ctx.languageOptions
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_b_form_checkbox, {
                              modelValue: _ctx.remember,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.remember) = $event)),
                              value: "1",
                              "unchecked-value": "0",
                              name: "check-button",
                              switch: "",
                              id: "remember"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", _hoisted_15, "   " + _toDisplayString(_ctx.t('remember_username')), 1)
                              ], undefined, true),
                              _: 1
                            }, 8, ["modelValue"]),
                            _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1))
                          ])
                        ]),
                        (_ctx.message)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.message), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_b_button, {
                          disabled: _ctx.loading,
                          type: "submit",
                          variant: "primary",
                          size: "lg",
                          class: "btn-block",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('login')), 1)
                          ], undefined, true),
                          _: 1
                        }, 8, ["disabled"])
                      ], 32),
                      false
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _cache[11] || (_cache[11] = _createElementVNode("div", {
                              class: "hr-text",
                              style: {"margin-bottom":"16px"}
                            }, "OAuth2", -1)),
                            _createVNode(_component_b_button, {
                              disabled: _ctx.loading,
                              type: "button",
                              variant: "primary",
                              size: "lg",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.OAuth2Microsoft();}),
                              class: "btn-block",
                              style: {"width":"100%","display":"flex","padding":"2px","background-color":"white","color":"rgb(96, 94, 94)","border-color":"rgb(96, 94, 94)"}
                            }, {
                              default: _withCtx(() => [
                                _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"background-color":"white","padding":"5px","width":"40px","height":"40px","border-radius":"2px"} }, [
                                  _createElementVNode("img", { src: "/assets/msicon.png" })
                                ], -1)),
                                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t('sign_in_microsoft')), 1)
                              ], undefined, true),
                              _: 1
                            }, 8, ["disabled"]),
                            _createVNode(_component_b_button, {
                              disabled: _ctx.loading,
                              type: "button",
                              variant: "primary",
                              size: "lg",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.OAuth2Google())),
                              class: "btn-block",
                              style: {"width":"100%","display":"flex","padding":"2px","background-color":"#4285f4"}
                            }, {
                              default: _withCtx(() => [
                                _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"background-color":"white","padding":"5px","width":"40px","height":"40px","border-radius":"2px"} }, [
                                  _createElementVNode("img", { src: "/assets/googleicon.png" })
                                ], -1)),
                                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t('sign_in_google')), 1)
                              ], undefined, true),
                              _: 1
                            }, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], undefined, true),
    _: 1
  }))
}